import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";

const HomePage = lazy(() => import("../pages/home/HomePage"));
const WhyRaviMatePage = lazy(() => import("../pages/why-ravimate/WhyRaviMatePage"));
const DatingInsightsPage = lazy(() => import("../pages/dating-insights/DatingInsightsPage"));
const RelationshipAcademyPage = lazy(() => import("../pages/relationship-academy/RelationshipAcademyPage"));
const SuccessStoriesPage = lazy(() => import("../pages/success-stories/SuccessStoriesPage"));
const SafeDatingTipsPage = lazy(() => import("../pages/safe-dating-tips/SafeDatingTipsPage"));
const HowRaviMateWorksPage = lazy(() => import("../pages/how-ravimate-works/HowRaviMateWorksPage"));
const SafetyPage = lazy(() => import("../pages/safety/SafetyPage"));
const FaqPage = lazy(() => import("../pages/faq/FaqPage"));
const TermsOfServicePage = lazy(() => import("../pages/terms-of-service/TermsOfServicePage"));
const GuidelinesPage = lazy(() => import("../pages/guidelines/GuidelinesPage"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/PrivacyPolicyPage"));
const AccountVerificationPage = lazy(() => import("../pages/account-verification/AccountVerificationPage"));
const AiPolicyPage = lazy(() => import("../pages/ai-policy/AiPolicyPage"));
const SubscriptionBillingPage = lazy(() => import("../pages/subscription-billing/SubscriptionBillingPage"));
const RefundPolicyPage = lazy(() => import("../pages/refund-policy/RefundPolicyPage"));
const ContentModerationPage = lazy(() => import("../pages/content-moderation/ContentModerationPage"));
const CopyrightPolicyPage = lazy(() => import("../pages/copyright-policy/CopyrightPolicyPage"));

const Fallback = () => (
  <div style={{ minHeight: "100vh", background: "#0a0a0a" }} />
);

const wrap = (Component) => (
  <Suspense fallback={<Fallback />}>
    <Component />
  </Suspense>
);

const router = createBrowserRouter(
  [
    { path: "/", element: wrap(HomePage) },
    { path: "/why-ravimate", element: wrap(WhyRaviMatePage) },
    { path: "/dating-insights", element: wrap(DatingInsightsPage) },
    { path: "/relationship-academy", element: wrap(RelationshipAcademyPage) },
    { path: "/success-stories", element: wrap(SuccessStoriesPage) },
    { path: "/safe-dating-tips", element: wrap(SafeDatingTipsPage) },
    { path: "/how-ravimate-works", element: wrap(HowRaviMateWorksPage) },
    { path: "/safety", element: wrap(SafetyPage) },
    { path: "/faq", element: wrap(FaqPage) },
    { path: "/terms-of-service", element: wrap(TermsOfServicePage) },
    { path: "/guidelines", element: wrap(GuidelinesPage) },
    { path: "/privacy-cookie-policy", element: wrap(PrivacyPolicyPage) },
    { path: "/account-verification", element: wrap(AccountVerificationPage) },
    { path: "/ai-policy", element: wrap(AiPolicyPage) },
    { path: "/subscription-billing", element: wrap(SubscriptionBillingPage) },
    { path: "/refund-policy", element: wrap(RefundPolicyPage) },
    { path: "/content-moderation", element: wrap(ContentModerationPage) },
    { path: "/copyright-policy", element: wrap(CopyrightPolicyPage) },
    { path: "*", element: <Navigate to="/" replace /> },
  ],
  { basename: process.env.REACT_APP_HOME_PAGE || "/" }
);

export default router;
